<div class="site-content">
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>

<div class="phone"><a href="tel:+919884476981"><img src="/assets/phone.gif"></a></div>
<div class="what"><a href="https://wa.me/919884476981"><img src="/assets/what.gif"></a></div>